import { render, staticRenderFns } from "./orderextendlist.vue?vue&type=template&id=2f23890a&scoped=true&"
import script from "./orderextendlist.vue?vue&type=script&lang=js&"
export * from "./orderextendlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23890a",
  null
  
)

export default component.exports